// S-5 §7 — pure check-digit validators. Normalize (strip spaces/dashes),
// empty or length-invalid input -> false, NEVER throw (an author's bad test
// value must render as a failed check, not a 500).
export const CHECK_DIGIT_SCHEMES = new Set(["luhn", "mod97", "aba"]);
function normalize(value) {
    return value.replace(/[\s-]/g, "");
}
function luhnValid(v) {
    if (!/^\d+$/.test(v) || v.length < 2)
        return false;
    let sum = 0;
    let double = false;
    for (let i = v.length - 1; i >= 0; i--) {
        let d = v.charCodeAt(i) - 48;
        if (double) {
            d *= 2;
            if (d > 9)
                d -= 9;
        }
        sum += d;
        double = !double;
    }
    return sum % 10 === 0;
}
/** IBAN mod-97 (ISO 7064 MOD 97-10): move the first 4 chars to the end,
 *  convert letters to numbers (A=10..Z=35), the resulting numeric string mod
 *  97 must equal 1. Computed digit-by-digit (running remainder) since the
 *  numeric string can be far longer than a safe JS integer. */
function mod97Valid(v) {
    if (v.length < 5 || !/^[A-Za-z0-9]+$/.test(v))
        return false;
    const rearranged = v.slice(4) + v.slice(0, 4);
    let remainder = 0;
    for (const ch of rearranged.toUpperCase()) {
        const code = ch.charCodeAt(0);
        if (code >= 48 && code <= 57) {
            remainder = (remainder * 10 + (code - 48)) % 97;
        }
        else if (code >= 65 && code <= 90) {
            const n = code - 55; // A=10 .. Z=35
            remainder = (remainder * 100 + n) % 97;
        }
        else {
            return false;
        }
    }
    return remainder === 1;
}
/** US ABA routing-number checksum: exactly 9 digits, weighted sum with
 *  weights [3,7,1,3,7,1,3,7,1] must be divisible by 10. */
function abaValid(v) {
    if (!/^\d{9}$/.test(v))
        return false;
    const weights = [3, 7, 1, 3, 7, 1, 3, 7, 1];
    let sum = 0;
    for (let i = 0; i < 9; i++)
        sum += (v.charCodeAt(i) - 48) * weights[i];
    return sum % 10 === 0;
}
export function checkDigitValid(scheme, value) {
    try {
        const v = normalize(value ?? "");
        if (!v)
            return false;
        switch (scheme) {
            case "luhn": return luhnValid(v);
            case "mod97": return mod97Valid(v);
            case "aba": return abaValid(v);
            default: return false;
        }
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=check-digit.js.map